import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';

import { LoginViaCode } from './pages/LoginViaCode';
import { Vroom } from './pages/Vroom';

function App(): JSX.Element {
    try {
        // Global const from outside of vroom on the host website

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line no-undef
        if (VroomCodeSnippetQueryStringParams) {
            return <Vroom />;
        }
    } catch {
        // do nothing
    }

    return (
        <APIProvider apiKey='AIzaSyCO4zpOQGRF6YH82al4_BiJ-xIcxqJOVPM'>
            <div data-testid='home' className='w-full h-full flex-center'>
                <Router>
                    <Routes>
                        {/* <Vroom /> Known Partner Journey */}
                        <Route path='/iframe/:id' element={<Vroom />} />
                        <Route path='/:id' element={<Vroom />} />
                        {/* Login via SMS Code */}
                        <Route path='/l/:code' element={<LoginViaCode />} />
                        {/* <Vroom /> Unknown Partner Journey */}
                        <Route path='*' element={<Vroom />} />
                    </Routes>
                </Router>
            </div>
        </APIProvider>
    );
}

export default App;
